import { render, staticRenderFns } from "./Calc.vue?vue&type=template&id=695f533b&scoped=true&"
import script from "./Calc.ts?vue&type=script&lang=ts&"
export * from "./Calc.ts?vue&type=script&lang=ts&"
import style0 from "./Calc.css?vue&type=style&index=0&id=695f533b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695f533b",
  null
  
)

export default component.exports